import "./Armsat.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import Introduction from "./sections/Introduction";
import TechnicalSpecifications from "./sections/TechnicalSpecifications";
import Operations from "./sections/Operations";
import Gallery from "./sections/Gallery";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function ArmsatPage() {
  return <div>
      <Header />
      <HeroSection />
      <Introduction />
      <TechnicalSpecifications />
      <Operations />
      <Gallery />
      <Contact />
      <Footer />
    </div>;
}